<template>
  <!-- Footer Section -->
  <section class="bg-primary py-[40px] md:py-[80px] px-5">
    <div class="l-width">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-between gap-10"
      >
        <div class="space-y-5 md:space-y-8">
          <div>
            <img src="/images/logo-white.png" alt="" />
          </div>
          <p class="text-xs md:text-sm lg:text-lg leading-6">
            We deliver professional Engine oil that best suites your Machine
            needs. Contact us today to supply you any of our products. We
            deliver nationwide.
          </p>
        </div>
        <div class="space-y-5 md:space-y-8 md:justify-self-center">
          <h3 class="font-bold text-white capitalize text-base md:text-lg">
            Explore
          </h3>
          <ul class="text-xs md:text-sm space-y-5 capitalize flex flex-col">
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('home') ? 'text-secondary ' : 'text-white'
              "
            >
              <router-link to="/home" class="hover:text-secondary"
                >home<span
                  :class="
                    active.includes('home')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span>
              </router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('about') ? 'text-secondary ' : 'text-white'
              "
            >
              <router-link class="hover:text-secondary" to="/about.html"
                >about us
                <span
                  :class="
                    active.includes('about')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('products/automotive')
                  ? 'text-secondary '
                  : 'text-white'
              "
            >
              <router-link
                class="hover:text-secondary"
                to="/products/automotive"
                >automotive oil
                <span
                  :class="
                    active.includes('products/automotive')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('products/industrial')
                  ? 'text-secondary '
                  : 'text-white'
              "
            >
              <router-link
                class="hover:text-secondary"
                to="/products/industrial"
                >industrial oils
                <span
                  :class="
                    active.includes('products/industrial')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('products/greases')
                  ? 'text-secondary '
                  : 'text-white'
              "
            >
              <router-link class="hover:text-secondary" to="/products/greases"
                >greases
                <span
                  :class="
                    active.includes('products/greases')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('products/quality-control')
                  ? 'text-secondary '
                  : 'text-white'
              "
            >
              <router-link
                class="hover:text-secondary"
                to="/products/quality-control"
                >quality control
                <span
                  :class="
                    active.includes('products/quality-control')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('careers') ? 'text-secondary ' : 'text-white'
              "
            >
              <router-link class="hover:text-secondary" to="/careers"
                >careers
                <span
                  :class="
                    active.includes('careers')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
            <li
              class="hover:text-secondary cursor-pointer text-xs sm:text-sm md:text-base"
              :class="
                active.includes('contact') ? 'text-secondary ' : 'text-white'
              "
            >
              <router-link class="hover:text-secondary" to="/contact"
                >contact
                <span
                  :class="
                    active.includes('contact')
                      ? 'block border-t-4 border-secondary w-[20px] mt-2'
                      : ''
                  "
                ></span
              ></router-link>
            </li>
          </ul>
        </div>
        <div class="space-y-5 md:space-y-8">
          <h3 class="font-bold text-white capitalize text-base md:text-lg">
            Lastest News
          </h3>
          <div
            class="text-xs md:text-sm space-y-5 capitalize hover:bg-accent cursor-pointer"
          >
            <div class="flex items-center gap-4">
              <div class="h-[50px] max-w-[50px]">
                <img src="/images/Shell-300x300.jpeg" alt="Shell" />
              </div>
              <div class="space-y-2">
                <h4 class="text-xs md:text-sm lg:text-lg">
                  Shell To Start Gas Supply To Dangote Fertilizer
                </h4>
                <p class="text-xs sm:text-sm md:text-base text-secondary">
                  February 5, 2024
                </p>
              </div>
            </div>
          </div>
          <div
            class="text-xs md:text-sm space-y-5 capitalize hover:bg-accent cursor-pointer"
          >
            <div class="flex items-center gap-4">
              <div class="h-[50px] max-w-[50px]">
                <img src="/images/christmas-pic1.jpeg" alt="christmas" />
              </div>
              <div class="space-y-2">
                <h4 class="text-xs md:text-sm lg:text-lg">
                  Welcome to the Month of February!
                </h4>
                <p class="text-sm md:text-base text-secondary">
                  February 5, 2024
                </p>
              </div>
            </div>
          </div>
          <div class="space-y-5 capitalize hover:bg-accent cursor-pointer">
            <div class="flex items-center gap-4">
              <div class="h-[50px] max-w-[50px]">
                <img src="/images/always-open.jpeg" alt="Always open" />
              </div>
              <div class="space-y-2">
                <h4 class="text-xs md:text-sm lg:text-lg">
                  We Are Always Open
                </h4>
                <p class="text-sm md:text-base text-secondary">
                  February 5, 2024
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-5 md:space-y-8">
          <h3 class="font-bold text-white capitalize text-base md:text-lg">
            Contact
          </h3>
          <div class="text-xs md:text-sm space-y-5 md:space-y-8">
            <div class="flex items-center gap-5">
              <img src="/icons/location.svg" alt="location" />
              <p class="text-xs sm:text-sm md:text-base">
                Plot 739 wole soyinka way 2nd Avenue gwarinpa Abuja
              </p>
            </div>
            <div class="flex items-center gap-5">
              <img src="/icons/call.svg" alt="" />
              <p class="text-xs sm:text-sm md:text-base">09033643177</p>
            </div>
            <div class="flex items-center gap-5">
              <img src="/icons/email.svg" alt="" />
              <p class="text-xs sm:text-sm md:text-base">
                <a href="mailto:"></a>info@lubxoil.ng
              </p>
            </div>

            <div class="flex items-center gap-5">
              <div
                class="border border-secondary p-3 rounded-full cursor-pointer hover:bg-secondary"
              >
                <a
                  href="https://twitter.com/lubx_engineoil"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><img src="/icons/twitter.svg" alt="twitter"
                /></a>
              </div>
              <div
                class="border border-secondary p-3 rounded-full cursor-pointer hover:bg-secondary"
              >
                <a
                  href="http://facebook.com/lubxengineoil"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><img src="/icons/facebook.svg" alt="facebook"
                /></a>
              </div>
              <div
                class="border border-secondary p-3 rounded-full cursor-pointer hover:bg-secondary"
              >
                <a
                  href="https://www.instagram.com/lubx_engine_oil/"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><img src="/icons/instagram.svg" alt="instagram"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr
      class="my-6 space-y-8 lg:space-y-10 border-0.5 border-[#333] l-width sm:mx-auto lg:my-14"
    />

    <p class="text-center text-xs">
      &copy; Copyright <span id="date"></span> by Lubx Oil and Gas Ltd
    </p>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
  name: "FooterComponent",

  data() {
    return {};
  },

  computed: {
    active() {
      return this.$route.path;
    },
  },
};
</script>
